<template>
  <div class="after">
    <div v-for="(value, key, i) in data" :key="i">
      <app-sel
        styling="inline"
        key-name="label"
        v-model="nutrients[key].active"
        :items="Object.values(nutrients[key].variants)"

        v-if="Object.values(nutrients[key].variants).length > 1"
      >
       <!-- @click.prevent="getOriginal(items[0].label, nutrients[key].active, nutrients[key].value)" -->
        <template v-slot="{ items }">
          <app-sel-opt
            
            :value="item"
            v-for="(item, j) in items"
            :key="j"
          >
            {{ item.label }}
          </app-sel-opt>
        </template>
      </app-sel>

      <span v-else>
        {{nutrients[key].active}}
      </span>

      <span v-if=" nutrients[key].variants[nutrients[key].active].factor == 1">
        {{nutrients[key].original.toFixed(2)}}
      </span>
      <span v-else>
        {{getFactoredValue(nutrients[key].variants[key].label, nutrients[key].active, nutrients[key].original).toFixed(2)}}
      </span>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {
      nutrients: {
        P: {
          value: 0,
          active: 'P',
          original: 0,
          variants: {
            P: {
              label: 'P',
              factor: 1,
            },
            PO4: {
              label: 'PO4',
              factor: 3.066,
            },
            P205: {
              label: 'P205',
              factor: 2.29,
            },
            H2PO4: {
              label: 'H2PO4',
              factor: 3.129,
            },
          }
        },
        K: {
          value: 0,
          active: 'K',
          original: 0,
          variants: {
            K: {
              label: 'K',
              factor: 1,
            },
            K2O: {
              label: 'K2O',
              factor: 1.205,
            },
          }
        },
        Ca: {
          value: 0,
          active: 'Ca',
          original: 0,
          variants: {
            Ca: {
              label: 'Ca',
              factor: 1,
            },
            CaO: {
              label: 'CaO',
              factor: 1.394,
            },
            CaCO3: {
              label: 'CaCO3',
              factor: 2.5,
            },
          }
        },
        Mg: {
          value: 0,
          active: 'Mg',
          original: 0,
          variants: {
            Mg: {
              label: 'Mg',
              factor: 1,
            },
            MgO: {
              label: 'MgO',
              factor: 1.6569,
            },
            MgCO3: {
              label: 'MgCO3',
              factor: 3.4669,
            },
          }
        },
        S: {
          value: 0,
          active: 'S',
          original: 0,
          variants: {
            S: {
              label: 'S',
              factor: 1,
            },
            SO4: {
              label: 'SO4',
              factor: 3,
            },
            SO3: {
              label: 'SO3',
              factor: 2.5,
            },
          }
        },
        CO3: {
          value: 0,
          active: 'CO3',
          original: 0,
          variants: {
            CO3: {
              label: 'CO3',
              factor: 1,
            },
          }
        },
        HCO3: {
          value: 0,
          active: 'HCO3',
          original: 0,
          variants: {
            HCO3: {
              label: 'HCO3',
              factor: 1,
            },
          }
        },
        Cl: {
          value: 0,
          active: 'Cl',
          original: 0,
          variants: {
            Cl: {
              label: 'Cl',
              factor: 1,
            },
          }
        },
        Na: {
          value: 0,
          active: 'Na',
          original: 0,
          variants: {
            Na: {
              label: 'Na',
              factor: 1,
            },
          }
        },
      },
    }
  },
  watch: {
    data (val) {
      this.setVal();
    },
    nutrients: {
      handler: function (val) {
        this.refreshVal();
      },
      deep: true
    }
  },

  computed: {
    
  },

  methods: {
    
    getFactoredValue(nut, active, value) {
      console.log(nut, active, value)
      let val = value * this.nutrients[nut].variants[active].factor;
      return val;
    },

    getVal: function (nut, active) {
      var val = this.nutrients[nut].original * (1 / this.nutrients[nut].variants[active].factor);
      return val.toFixed(2);
    },
    getOriginal: function (nut, active, value) {
      var val = value / (1 / this.nutrients[nut].variants[active].factor);
      console.log(val)
      return val;
    },
    setVal: function () {
      for (var key in this.data) {
        if (this.nutrients[key]) {
          this.nutrients[key].active = key;
          this.nutrients[key].original = this.getOriginal(key, this.nutrients[key].active, this.data[key]);
          this.nutrients[key].value = this.getVal(key, this.nutrients[key].active);
        }
      }
    },
    refreshVal: function () {
      for (var key in this.data) {
        if (this.nutrients[key]) {
          this.nutrients[key].value = this.getVal(key, this.nutrients[key].active);
        }
      }
    }
  },
  created () {
    console.log(this.data);
    this.setVal();
  }
}
</script>

<style lang="scss" scoped>
  .after {
    width: 100%;

    &>div {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 200px 12px 0px;
      border-top: solid 1px rgba(76, 80, 86, 0.1);
      border-bottom: solid 1px rgba(76, 80, 86, 0.1);

      span {
        font-size: 16px;
        font-weight: 400;
      }

      @media (max-width: 500px) {
        padding: 12px 0 12px 0px;
      }
    }
  }
</style>
